import React from 'react';
import TituloMuroBambooEspejo from '../components/sections/MuroBambooEspejo/TituloMuroBambooEspejo'; 
import IntroMuroBambooEspejo from '../components/sections/MuroBambooEspejo/IntroMuroBambooEspejo'; 
import CaracteristicasMuroBambooEspejo from '../components/sections/MuroBambooEspejo/CaracteristicasMuroBambooEspejo';   
import CatalogoMuroBambooEspejo from '../components/sections/MuroBambooEspejo/CatalogoMuroBambooEspejo';
import FormularioContactoBambooEspejo from '../components/sections/MuroBambooEspejo/FormularioContactoBambooEspejo';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroBambooEspejo = () => {
  return (
    <div>
      <Header />
        <TituloMuroBambooEspejo />   
        <IntroMuroBambooEspejo />  
        <CaracteristicasMuroBambooEspejo />   
        <CatalogoMuroBambooEspejo />  
        <FormularioContactoBambooEspejo />
      <Footer />
    </div>
  );
};

export default MuroBambooEspejo;